import axios from "axios";
import { AUTH_URL, CONTENT_URL } from "../util/config";
var instance = axios.create();
instance.defaults.timeout = 8000;
// instance.defaults.withCredentials = true;
instance.defaults.baseURL = AUTH_URL;
// http request 拦截器
instance.interceptors.request.use(
  config => {
    // config.data = JSON.stringify(config.data)
    // console.log(config.data)
    // config.headers = {
    //   'Content-Type': 'application/x-www-form-urlencoded'
    //   // 'Content-Type': 'application/json;charset=utf-8'
    // }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 响应拦截器即异常处理
instance.interceptors.response.use(
  response => {
    return response;
  },
  err => {
    if (err && err.response) {
      switch (err.response.status) {
        case 400:
          console.log("错误请求");
          break;
        case 401:
          console.log("未授权，请重新登录");
          break;
        case 403:
          console.log("拒绝访问");
          break;
        case 404:
          console.log("请求错误,未找到该资源");
          break;
        case 405:
          console.log("请求方法未允许");
          break;
        case 408:
          console.log("请求超时");
          break;
        case 500:
          console.log("服务器端出错");
          break;
        case 501:
          console.log("网络未实现");
          break;
        case 502:
          console.log("网络错误");
          break;
        case 503:
          console.log("服务不可用");
          break;
        case 504:
          console.log("网络超时");
          break;
        case 505:
          console.log("http版本不支持该请求");
          break;
        default:
          console.log(`连接错误${err.response.status}`);
      }
    } else {
      console.log("连接到服务器失败", err);
    }
    return Promise.resolve(err.response);
  }
);

/**
 * 封装ajax方法
 * @param url 接口路径
 * @param token 用户token
 * @param params 参数
 * @param needLogin 是否需要登录
 * @param method 请求类型
 * @param baseURL 接口域名
 * @returns {Promise}
 */
export function request(
  url,
  token,
  params = {},
  needLogin = 1,
  method = "GET",
  baseURL = "",
  headers = ""
) {
  if (!token && needLogin) {
    window.location.href = window.location.href.split("?")[0] + "?login=1";
    return;
  }
  let header = headers?headers:{
    "Content-Type": "application/x-www-form-urlencoded",
  };
  if (token) header.token = token;
  return new Promise((resolve, reject) => {
    let requestConfig = {
      url: url,
      headers: header,
      method
    };
    if (method.toLocaleLowerCase() == "get" && params) {
      requestConfig.params = params;
    } else if (method.toLocaleLowerCase() == "post" && params) {
      if(header&&header["Content-Type"]&&header["Content-Type"].toLocaleLowerCase()=='multipart/form-data'){
        let formData=new FormData();
        for(let o in params){
          formData.append(o,params[o]);
        }
        requestConfig.data = formData;
      }else 
        requestConfig.data = params;
    }
    if (baseURL) {
      requestConfig.baseURL = baseURL;
    }
    instance({
      ...requestConfig
    })
      .then(response => {
        resolve(response.data);
      })
      .catch(err => {
        console.error(err);
        reject(err);
      });
  });
}

/**
 * 封装get方法
 * @param url 接口路径
 * @param token 用户token
 * @param params 参数
 * @param needLogin 是否需要登录
 * @param baseURL 接口域名
 * @returns {Promise}
 */
export function fetch(url, token, params = {}, needLogin = 1, baseURL = "") {
  return request(url, token, params, needLogin, "GET", baseURL);
}

export function fetch1(url, token, params = {}, needLogin = 1) {
  return request(url, token, params, needLogin, "GET", CONTENT_URL);
}

export function fetch2(url, token, params = {}, needLogin = 1) {
  return request(url, token, params, needLogin, "GET", AUTH_URL);
}

/**
 * 封装post请求
 * @param url 接口路径
 * @param token 用户token
 * @param data 参数
 * @param needLogin 是否需要登录
 * @param baseURL 接口域名
 * @returns {Promise}
 */
export function post(url, token, data = {}, needLogin = 1, baseURL = "") {
  console.log(data)
  return request(url, token, data, needLogin, "POST", baseURL, {
    "Content-Type": "multipart/form-data"
  });
}

export function post1(url, token, data = {}, needLogin = 1) {
  return request(url, token, data, needLogin, "POST", CONTENT_URL, {
    "Content-Type": "multipart/form-data"
  });
}

export function post2(url, token, data = {}, needLogin = 1) {
  return request(url, token, data, needLogin, "POST", AUTH_URL);
}



// WEBPACK FOOTER //
// ./src/axios/index.js